import axios from 'axios';
import _ from 'lodash';

const DEFAULT_OPTIONS = {
  timeout: 60000,
  baseURL: process.env.VUE_APP_BASE_URL,
};

const GET_DEFAULT_OPTIONS = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const POST_DEFAULT_OPTIONS = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export default function request(options = {}) {
  return new Promise((resolve, reject) => {
    const { method } = options;
    const mergedOptions = {};

    if (method && method.toLowerCase() === 'get') {
      _.merge(mergedOptions, DEFAULT_OPTIONS, GET_DEFAULT_OPTIONS, options);
    } else if (method && method.toLowerCase() === 'post') {
      _.merge(mergedOptions, DEFAULT_OPTIONS, POST_DEFAULT_OPTIONS, options);
      if (mergedOptions.data && typeof mergedOptions.data === 'object') {
        mergedOptions.data = JSON.stringify(mergedOptions.data);
      }
    } else {
      _.merge(mergedOptions, DEFAULT_OPTIONS, options);
    }

    axios(mergedOptions).then((response) => {
      if (mergedOptions.responseType === 'blob') {
        resolve(response);
        return response;
      }
      const { data } = response;

      if (/^2\d+/.test(data.code) || data.code === 0) {
        resolve(data);
      } else {
        reject(data);
      }
      return data;
    }).catch((error) => {
      let reason = null;
      if (error.response) {
        reason = `${error.response.status}: ${error.response.statusText}`;
      } else if (error.request && error.request.status !== 0) {
        reason = `${error.request.status}: ${error.request.statusText}`;
      } else if (error.message === 'Network Error') {
        reason = '当前网络状况不佳，请稍后重试';
      } else {
        reason = error.message;
      }
      reject(reason);
    });
  });
}
